var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"it"},[_c('top-banner',{attrs:{"title":"Join Our Team","subtitle":"Enhance and grow your career by applying to work with STS's experienced experts","topimage":_vm.image}}),_c('navbar'),_c('work')],1)}
var staticRenderFns = []

export { render, staticRenderFns }